"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var data_access_1 = require("./data-access");
exports.declareResourceType = data_access_1.declareResourceType;
exports.State = data_access_1.State;
exports.hasLoadedWithoutError = data_access_1.hasLoadedWithoutError;
exports.isLoading = data_access_1.isLoading;
exports.isErrored = data_access_1.isErrored;
exports.LoadingInstance = data_access_1.LoadingInstance;
exports.ErroredInstance = data_access_1.ErroredInstance;
